export enum LanguageCode {
  EN = 'en', // English
  IT = 'it', // Italian
  ES = 'es', // Spanish
  FR = 'fr', // French
  DE = 'de', // German
  PT = 'pt', // Portuguese
  RU = 'ru', // Russian
  ZH = 'zh', // Chinese
  JA = 'ja', // Japanese
  AR = 'ar', // Arabic
}
